import { motion } from "framer-motion";
import { MapPin, Radio } from "lucide-react";
import { ParallaxImage } from "@/components/ParallaxImage";
import { KineticText } from "@/components/KineticText";
import { STATION } from "@/data/profile";

export const Station = () => (
  <section id="station" data-testid="station-section" className="section-dark border-t hairline">
    <div className="grid grid-cols-12">
      <div className="col-span-12 md:col-span-7 px-6 md:px-12 py-16 md:py-24 flex flex-col justify-between border-b md:border-b-0 md:border-r hairline">
        <div className="flex items-center gap-3 eyebrow">
          <span className="live-dot inline-block w-2 h-2 bg-[var(--accent)]" />
          <Radio size={12} className="text-[var(--accent)]" />
          {STATION.label} · {STATION.status}
        </div>
        <div className="mt-12 md:mt-20">
          <KineticText
            as="h2"
            lines={["Gulf of", "Mexico"]}
            testId="station-region"
            className="font-display font-bold uppercase leading-[0.86] text-[clamp(3.5rem,9vw,9rem)]"
          />
          <p className="mt-6 text-sm md:text-base text-muted max-w-lg">
            Michael is currently deployed on an ongoing deepwater project in the Gulf of Mexico under Warden Offshore Engineering. Consultancy enquiries for later slots remain open.
          </p>
        </div>
        <dl className="mt-12 grid grid-cols-2 sm:grid-cols-3 gap-6 border-t hairline pt-6">
          <div>
            <dt className="eyebrow flex items-center gap-2"><MapPin size={11} /> Position</dt>
            <dd className="mt-2 text-sm" data-testid="station-coords">{STATION.coords}</dd>
          </div>
          <div>
            <dt className="eyebrow">Role</dt>
            <dd className="mt-2 text-sm">{STATION.role}</dd>
          </div>
          <div>
            <dt className="eyebrow">On station since</dt>
            <dd className="mt-2 text-sm">{STATION.since}</dd>
          </div>
        </dl>
      </div>
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
        className="col-span-12 md:col-span-5 relative"
      >
        <ParallaxImage src={STATION.image} alt="Michael J. Warden on deck, Gulf of Mexico" className="h-full min-h-[420px] md:min-h-[640px]" strength={8} testId="station-image" />
        <span className="absolute bottom-4 left-4 md:left-6 eyebrow !text-white/80 bg-[#1b2229]/70 backdrop-blur px-3 py-2">Back deck · pipe-lay spread · Gulf of Mexico</span>
      </motion.div>
    </div>
  </section>
);
